const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.my_company_members/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.my_company_members/LIST_MY_COMPANY_MEMBERS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };

    case 'table.my_company_members/READ_COMPANY_MEMBER_SUCCESS':
      return {
        ...state,
        flyout: action.response.data,
      };

    case 'table.my_company_members/READ_MY_COMPANY_MEMBER_HISTORY_SUCCESS':
      return {
        ...state,
        flyout: {
          ...state.flyout,
          history: action.response.data,
        },
      };

    default:
      return state;
  }
}
